// AUTO-GENERATED by execution/city_index_gate.py; DO NOT EDIT.
// Source: business/ishvaram/data/governance/city_index_registry.json
// New membership can only be written by the evidence-validating promotion gate.

export const CHOGHADIYA_INDEXABLE_CITY_SLUGS: readonly string[] = [
  "agra",
  "ajmer",
  "alwar",
  "anand",
  "bhavnagar",
  "bhilwara",
  "bhopal",
  "bikaner",
  "chandigarh",
  "dehradun",
  "faridabad",
  "gandhinagar",
  "ghaziabad",
  "gurugram",
  "guwahati",
  "jabalpur",
  "jammu",
  "jamnagar",
  "kanpur",
  "kolhapur",
  "kota",
  "lucknow",
  "mathura",
  "nagpur",
  "nashik",
  "new-delhi",
  "noida",
  "patna",
  "raipur",
  "rajkot",
  "sikar",
  "udaipur",
  "ujjain",
];

export const PANCHANG_INDEXABLE_CITY_SLUGS: readonly string[] = [
  "agartala",
  "agra",
  "ahmedabad",
  "ajmer",
  "alappuzha",
  "aligarh",
  "allahabad",
  "alwar",
  "ambala",
  "amravati",
  "amritsar",
  "anand",
  "aurangabad",
  "ayodhya",
  "badrinath",
  "bangalore",
  "bardhaman",
  "bareilly",
  "begusarai",
  "bhagalpur",
  "bhavnagar",
  "bhilai",
  "bhilwara",
  "bhopal",
  "bikaner",
  "bilaspur-cg",
  "bodh-gaya",
  "chandigarh",
  "chennai",
  "coimbatore",
  "cuttack",
  "darbhanga",
  "dehradun",
  "dewas",
  "dibrugarh",
  "durg",
  "dwarka",
  "faridabad",
  "firozabad",
  "gangtok",
  "gaya",
  "ghaziabad",
  "gorakhpur",
  "guntur",
  "gurugram",
  "guwahati",
  "gwalior",
  "haldwani",
  "haridwar",
  "hisar",
  "hubli",
  "hyderabad",
  "imphal",
  "indore",
  "jabalpur",
  "jalandhar",
  "jalgaon",
  "jammu",
  "jamnagar",
  "jamshedpur",
  "jhansi",
  "kadapa",
  "kakinada",
  "kalaburagi",
  "kanpur",
  "karimnagar",
  "karnal",
  "kedarnath",
  "kochi",
  "kolkata",
  "kollam",
  "kota",
  "kozhikode",
  "kurnool",
  "lucknow",
  "ludhiana",
  "madurai",
  "malda",
  "mandi",
  "mangaluru",
  "mathura",
  "meerut",
  "mohali",
  "mumbai",
  "muzaffarnagar",
  "muzaffarpur",
  "mysore",
  "nagpur",
  "nainital",
  "nashik",
  "nizamabad",
  "palakkad",
  "palani",
  "panipat",
  "pathankot",
  "patiala",
  "patna",
  "pune",
  "purnea",
  "pushkar",
  "raipur",
  "rajahmundry",
  "rajkot",
  "ranchi",
  "ratlam",
  "rewa",
  "rishikesh",
  "rohtak",
  "roorkee",
  "rourkela",
  "rudrapur",
  "sagar",
  "sangli",
  "shillong",
  "shimla",
  "shirdi",
  "sikar",
  "solapur",
  "somnath",
  "sonipat",
  "srinagar",
  "surat",
  "thane",
  "thanjavur",
  "thiruvananthapuram",
  "tiruchirappalli",
  "tirupati",
  "tirupur",
  "udaipur",
  "udupi",
  "ujjain",
  "varanasi",
  "vellore",
  "vijayawada",
  "visakhapatnam",
  "vrindavan",
];

export const RAHU_KAAL_INDEXABLE_CITY_SLUGS: readonly string[] = [
  "agartala",
  "ahmedabad",
  "ajmer",
  "aligarh",
  "allahabad",
  "alwar",
  "ambala",
  "amritsar",
  "aurangabad",
  "ayodhya",
  "ballari",
  "bangalore",
  "begusarai",
  "bhagalpur",
  "bharatpur",
  "bhilai",
  "bhubaneswar",
  "bikaner",
  "bilaspur-cg",
  "bokaro",
  "chandigarh",
  "chennai",
  "cuttack",
  "dehradun",
  "dhanbad",
  "firozabad",
  "ghaziabad",
  "gurugram",
  "guwahati",
  "gwalior",
  "hapur",
  "haridwar",
  "hisar",
  "hubli",
  "hyderabad",
  "indore",
  "jabalpur",
  "jalgaon",
  "jhansi",
  "jodhpur",
  "kakinada",
  "kalaburagi",
  "kanpur",
  "karnal",
  "kochi",
  "kolhapur",
  "kolkata",
  "korba",
  "kota",
  "latur",
  "lucknow",
  "ludhiana",
  "madurai",
  "mathura",
  "meerut",
  "mohali",
  "moradabad",
  "muzaffarnagar",
  "muzaffarpur",
  "mysore",
  "nanded",
  "nellore",
  "noida",
  "palakkad",
  "panipat",
  "patiala",
  "patna",
  "pushkar",
  "raipur",
  "rajkot",
  "ranchi",
  "rewa",
  "rishikesh",
  "rourkela",
  "rudrapur",
  "sagar",
  "saharanpur",
  "sangli",
  "satna",
  "shimla",
  "sikar",
  "solan",
  "solapur",
  "sonipat",
  "srinagar",
  "surat",
  "thanjavur",
  "tirupati",
  "tumkur",
  "udaipur",
  "ujjain",
  "varanasi",
  "warangal",
  "yamunanagar",
];

export const SHUBH_MUHURAT_INDEXABLE_CITY_SLUGS: readonly string[] = [
  "agra",
  "ahmedabad",
  "allahabad",
  "alwar",
  "ambala",
  "aurangabad",
  "bhagalpur",
  "bhilai",
  "bhilwara",
  "bhopal",
  "bhubaneswar",
  "chandigarh",
  "chennai",
  "dibrugarh",
  "durg",
  "durgapur",
  "dwarka",
  "ghaziabad",
  "guwahati",
  "haridwar",
  "howrah",
  "indore",
  "jaipur",
  "jalandhar",
  "jammu",
  "jamnagar",
  "kolhapur",
  "kolkata",
  "lucknow",
  "mathura",
  "mohali",
  "muzaffarnagar",
  "nagpur",
  "nellore",
  "noida",
  "panipat",
  "pathankot",
  "patiala",
  "raipur",
  "rajkot",
  "rishikesh",
  "rourkela",
  "sangli",
  "sikar",
  "tirupati",
  "tirupur",
  "udaipur",
  "vadodara",
  "visakhapatnam",
];
